import { Button, DialogActions, DialogContent, DialogTitle, Modal, ModalDialog, Textarea, Typography } from "@mui/joy";
import React from "react";
import WrappedButton from "../WrappedButton";

interface BypassFiftyPercentPaymentDialogProps {
	open: boolean;
	invoiceNumber: string;
	packingListId: string;
	onClose: () => void;
	onSaved: () => void;
}

export default function BypassFiftyPercentPaymentDialog(props: BypassFiftyPercentPaymentDialogProps) {
	const [note, setNote] = React.useState("");
	const [isSaving, setIsSaving] = React.useState(false);

	React.useEffect(() => {
		if (props.open) {
			setNote("");
		}
	}, [props.open]);

	const saveBypass = () => {
		if (!note.trim()) {
			alert("A note is required.");
			return;
		}

		setIsSaving(true);
		fetch("PackingList/BypassFiftyPercentPayment", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				packingListId: props.packingListId,
				note: note.trim(),
			}),
		}).then(() => {
			setIsSaving(false);
			props.onSaved();
		});
	};

	return (
		<Modal open={props.open}>
			<ModalDialog sx={{ width: 500 }}>
				<DialogTitle>Bypass 50% Payment</DialogTitle>
				<DialogContent>
					<Typography level="body-sm" sx={{ mb: 2 }}>
						Estimate <strong>{props.invoiceNumber}</strong>
					</Typography>
					<Typography level="body-sm" sx={{ mb: 1 }}>
						Note:
					</Typography>
					<Textarea
						value={note}
						onChange={(e) => setNote(e.target.value)}
						minRows={3}
						placeholder="Enter reason for bypassing 50% payment requirement..."
						sx={{ width: "100%" }}
					/>
				</DialogContent>
				<DialogActions>
					<WrappedButton onClick={saveBypass} busy={isSaving}>
						Bypass
					</WrappedButton>
					<Button onClick={props.onClose} color="primary">
						Cancel
					</Button>
				</DialogActions>
			</ModalDialog>
		</Modal>
	);
}
